module.exports = __webpack_public_path__ + "img/bim360_logo.a5fe6fa9.svg";